import API from "../config/api.js";

export const InventoryService = {

    getBranches() {
        return API.get("/api/inventory/branches");
      },

    getSuppliers() {
        return API.get("/api/inventory/suppliers");
    },

    getProducts() {
        return API.get("/api/inventory/products");
    },


    async createInventory(payload) {
        try {
          const response = await API.post("/api/inventory/create", payload);
          return response;
        } catch (error) {
          // Log the full error object
          console.error("Error creating inventory:", error);
          throw error; // Re-throw the error for the caller to handle
        }
      },

      getInventoryList(search = "", page = 1) {
        return API.get("/api/inventory/inventories", {
          params: { search, page },
        });
      },

}